import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  signal,
} from "@angular/core";
import { QUANTITE_OF_DATA } from "../../models/data.model";
import { SharedModule } from "../../../../shared/shared.module";
import { WidgetHelperService } from "../../services/widget-helper.service";
import { Widget } from "../../models/dashboard.model";
import { EntityMetadata } from "../../../../shared/store/store-types.model";
import { IconOfEtatComponent } from "../../../of/components/icon-of-etat/icon-of-etat.component";
import { WidgetTitleComponent } from "../../../../shared/components/widget-title/widget-title.component";
import { parseNumber } from "../../../../shared/utils/number-utils.service";

@Component({
  selector: "vl-widget-quantite-of",
  standalone: true,
  imports: [SharedModule, IconOfEtatComponent, WidgetTitleComponent],
  host: { class: "widget-component" },
  templateUrl: "./widget-quantite-of.component.html",
  styleUrl: "./widget-quantite-of.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetQuantiteOfComponent {
  data = input<QUANTITE_OF_DATA>();
  metadata = input<EntityMetadata>();
  widget = input<Widget>();

  filters = signal({ yearScale: new Date().getFullYear().toString() });
  years = computed(() =>
    this.data()
      ?.data?.map((d) => d.date)
      .sort((a, b) => parseNumber(a) - parseNumber(b)),
  );
  arrayDatas = computed(() =>
    WidgetHelperService.getQuantiteOfChart(
      this.data()?.data,
      this.filters().yearScale,
    ).filter((e) => e.value),
  );
}
